import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import React from 'react'
import ReopenJobAsAdminViewModel from './ReopenJobAsAdminViewModel'
import { Form, FormRow, TextAreaContainer } from 'components/inputs'
import Button from 'components/Button'
import styles from './ReopenJobAsAdmin.sass'
import ErrorBlock from 'components/ErrorBlock'

interface ReopenJobAsAdminProps {
  vm: ReopenJobAsAdminViewModel
}

export default observer(function ReopenJobAsAdminDialog({
  vm,
}: ReopenJobAsAdminProps) {
  return (
    <ModalSheet
      showing={vm.showing}
      onRequestClose={vm.reopenJobAsAdmin.pending ? undefined : vm.close}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <div className={styles.contentBlock}>
          <ModalSheetContentIllustration
            src={require('assets/images/img_missing-permissions.svg')}
            alt="Illustration of hand holding a STOP symbol"
          />

          <ModalSheetContentTitle compact>
            <span className={styles.title}>
              Are you sure you want to reopen this job?
            </span>
          </ModalSheetContentTitle>

          <ModalSheetContentDescription compact>
            <span className={styles.description}>
              All associated users will be notified of this change
            </span>
          </ModalSheetContentDescription>
        </div>

        <ModalSheetContentBlock>
          <Form>
            <FormRow className={styles.row}></FormRow>
            <FormRow className={styles.row}>
              <div className={styles.reasonLabel}>Reason</div>
              <TextAreaContainer
                model={vm}
                field="reason"
                name="reason"
                error={vm.validation.getError('reason')}
                data-test="reopen-job-as-admin-reason-input"
                rows={4}
              />
              <div className={styles.reasonHelp}>{vm.reasonHelpText}</div>
            </FormRow>
          </Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      {vm.reopenJobAsAdmin.rejected && (
        <ErrorBlock tackOn="bottom" error={vm.reopenJobAsAdmin.error} />
      )}

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Close
          </Button>
          <Button
            type="danger"
            loading={vm.reopenJobAsAdmin.pending}
            data-test="reopen-job-as-admin-submit-button"
            onClick={vm.reopenJobAsAdmin}
          >
            Reopen
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
